/* ga-stamped-es.js — Spanish pages only (loaded by layout/theme.liquid when locale is es).
   Stamped renders its star-badge caption in English ("251 reviews") on every locale.
   This rewrites only that visible caption text after Stamped renders it; no Stamped
   settings, reviews or app data are changed. */
(function () {
  var RX = /^\s*([\d.,]+)\s+reviews?\s*$/i;
  function fix(root) {
    var nodes = (root || document).querySelectorAll('.stamped-badge-caption');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = walker.nextNode())) {
        var m = n.nodeValue.match(RX);
        if (m) n.nodeValue = m[1] + (m[1] === '1' ? ' reseña' : ' reseñas');
        else if (/^\s*reviews?\s*$/i.test(n.nodeValue)) n.nodeValue = ' reseñas';
      }
      // Stamped prints the word via CSS from data-label ("reviews"); swap it on the rendered element only.
      var label = el.getAttribute('data-label');
      if (label && /^reviews?$/i.test(label)) {
        el.setAttribute('data-label', el.getAttribute('data-reviews') === '1' ? 'reseña' : 'reseñas');
      }
      if (el.getAttribute('aria-label')) el.setAttribute('aria-label', el.getAttribute('aria-label').replace(/reviews?/i, 'reseñas'));
    }
  }
  var pending = false;
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; fix(); });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  fix();
  // Stamped finishes within a few seconds; stop observing afterwards to keep the page light.
  setTimeout(function () { mo.disconnect(); fix(); }, 15000);
})();
